import { useEffect, useState } from "react"
import { Link, useSearchParams } from "react-router-dom"
import modernLogo from "../../../assets/mofoIcon.png"
import { jwtDecode } from "jwt-decode"
import { EmailVerificationForm } from "./EmailVerificationForm"
import { ConfirmPasswordForm } from "./ConfirmPasswordForm"
import MainLayout from "../../components/layout";
import LinkExpired from "../../components/modal/LinkExpired";

type DecodedToken = {
	email: string
	exp: number
	[key: string]: unknown
}

export function ForgotPassword() {
	const [step, setStep] = useState<"request" | "confirm">("request")
	const [email, setEmail] = useState("")
	const [searchParams] = useSearchParams()
	const tokenCode = searchParams.get("code")
	const [loading, setLoading] = useState<boolean>(true)
	const [decodedEmail, setDecodedEmail] = useState("")
	const [tokenExpired, setTokenExpired] = useState(false)

	useEffect(() => {
		if (!tokenCode) {
			setLoading(false)
			return
		}

		try {
			const decoded = jwtDecode<DecodedToken>(tokenCode)
			const currentTime = Math.floor(Date.now() / 1000)
			if (decoded?.exp && decoded.exp < currentTime) {
				setTokenExpired(true)
				setLoading(false)
				return
			}

			if (decoded?.email) {
				setDecodedEmail(decoded.email)
			} else {
				setLoading(false)
			}
		} catch {
			setLoading(false)
		}
	}, [tokenCode])

	useEffect(() => {
		if (!decodedEmail) return

		const verifyEmailAndSendCode = async () => {
			try {
				if (decodedEmail) {
					const lowerEmail = decodedEmail.trim().toLowerCase()
					setEmail(lowerEmail)
					console.log("Sending verifiction code - email: ", lowerEmail)
				}
			} catch (error) {
				console.error("Reset password failed", error)
				setStep("request")
			} finally {
				setLoading(false)
			}
		}

		verifyEmailAndSendCode()
	}, [decodedEmail])

	const handleStepChange = async (
		nextStep: "request" | "confirm",
		email?: string,
	) => {
		if (email) setEmail(email)
		setStep(nextStep)
	}

	return (
		<MainLayout showHeader={false}>
			<div className="flex flex-col items-center justify-between bg-white px-4">
				<div className="mx-auto w-full max-w-md bg-white p-2 sm:max-w-lg sm:p-2 md:p-4 lg:max-w-md xl:max-w-[480px]">
					<div className="mb-6 flex w-full content-center items-center justify-center tracking-wide">
						<img
							src={modernLogo}
							alt="modern football"
							width={"130px"}
							height={"40px"}
						/>
					</div>
					{tokenExpired ? (
						<LinkExpired />
					) : (
						<div>
							<h2 className="mb-4 text-center text-2xl font-bold text-gray-950">
								Create Your Password
							</h2>
							{!loading && (
								<>
									{step === "request" && (
										<EmailVerificationForm
											verificationCodeSent={handleStepChange}
											email={decodedEmail ? decodedEmail : ""}
										/>
									)}
									{step === "confirm" && (
										<ConfirmPasswordForm email={email} tokenCode={tokenCode} />
									)}
								</>
							)}
							<div className="mt-4 text-center text-sm">
								<Link to="/" className="text-[#9CA3AF]">
									Already have an account? Login
								</Link>
							</div>
						</div>
					)}
				</div>
			</div>
		</MainLayout>
	)
}
